import { PAYMENT_INIT_FAIL_SCREEN_LEVEL_HALF, PAYMENT_INIT_FAIL_SCREEN_LEVEL_ONE, PROGRESS } from 'config/config';
import withProgressBar from 'hoc/withProgressBar';
import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { ILoadingState } from 'types/ILoadingState';

import Spinner from '../../spinner/Spinner';

import {
  PaymentInitFailScreenBackButton,
  PaymentInitFailScreenButtonWrapper,
  PaymentInitFailScreenContainer,
  PaymentInitFailScreenIcon,
  PaymentInitFailScreenMessageTitle,
  PaymentInitFailScreenMessageContent,
  PaymentInitFailScreenPageTitle,
  PaymentInitFailScreenWrapper,
} from './PaymentInitFailScreen.styles';

interface IState {
  redirectUrl: string;
  isPaymentMethodSelected: boolean;
}
class PaymentInitFailScreen extends PureComponent<IState & Partial<IContext> & Partial<ITextContext>, ILoadingState> {
  innerRef = React.createRef<HTMLDivElement>();

  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
    };
  }

  handleClick = () => {
    const { redirectUrl, isPaymentMethodSelected } = this.props;

    if (isPaymentMethodSelected) {
      window.location.assign(redirectUrl);
    } else {
      window.location.assign(window.location.href.replace('/init-failed', ''));
    }
  };

  render() {
    const { isPaymentMethodSelected } = this.props;
    const { pageTitle, icon, messageTitle, messageContent, buttonText } = isPaymentMethodSelected
      ? PAYMENT_INIT_FAIL_SCREEN_LEVEL_HALF
      : PAYMENT_INIT_FAIL_SCREEN_LEVEL_ONE;
    const { isLoading } = this.state;
    const containerHeight = this.innerRef.current ? this.innerRef.current.offsetHeight : 0;

    return (
      <PaymentInitFailScreenContainer
        isLoading={isLoading as boolean}
        height={containerHeight}
        ref={this.innerRef}
        className="payment-init-fail__container"
      >
        {isLoading ? (
          <Spinner isLoading={isLoading} />
        ) : (
          <PaymentInitFailScreenWrapper>
            <PaymentInitFailScreenPageTitle className="payment-init-fail__page-title">
              <FormattedMessage id={pageTitle} />
            </PaymentInitFailScreenPageTitle>
            <PaymentInitFailScreenIcon className="payment-init-fail__icon">
              <img src={icon} alt="icon" />
            </PaymentInitFailScreenIcon>
            <PaymentInitFailScreenMessageTitle className="payment-init-fail__message-title">
              <FormattedMessage id={messageTitle} />
            </PaymentInitFailScreenMessageTitle>
            <PaymentInitFailScreenMessageContent className="payment-init-fail__message-content">
              <FormattedMessage id={messageContent} />
            </PaymentInitFailScreenMessageContent>
            <PaymentInitFailScreenButtonWrapper>
              <PaymentInitFailScreenBackButton
                onClick={this.handleClick}
                className="payment-init-fail-screen__back-button"
                id="back"
              >
                <FormattedMessage id={buttonText} />
              </PaymentInitFailScreenBackButton>
            </PaymentInitFailScreenButtonWrapper>
          </PaymentInitFailScreenWrapper>
        )}
      </PaymentInitFailScreenContainer>
    );
  }
}

export default withProgressBar(PROGRESS.PAYMENT_FAILURE)(PaymentInitFailScreen);
